import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Modal, EmptyState } from "@/components/pcp";
import { Plus, Pencil, TrashSimple, Users } from "@phosphor-icons/react";
import { toast } from "sonner";

const empty = { nome: "", supervisor: "", membros: [], veiculos: "", regiao: "" };

export default function Equipes() {
  const [items, setItems] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);
  const [membroTxt, setMembroTxt] = useState("");

  const load = () => api.get("/equipes").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { ...form, membros: membroTxt.split(",").map(s => s.trim()).filter(Boolean) };
      if (editId) await api.put(`/equipes/${editId}`, payload);
      else await api.post("/equipes", payload);
      toast.success("Equipe salva"); setModal(false); load();
    } catch { toast.error("Erro ao salvar"); }
  };

  const openEdit = (e) => {
    setForm({ ...empty, ...e });
    setMembroTxt((e.membros || []).join(", "));
    setEditId(e.id);
    setModal(true);
  };

  const remove = async (e) => {
    if (!window.confirm(`Excluir a equipe "${e.nome}"?\n\nAgendamentos e OS vinculados a ela permanecerão, mas ficarão sem equipe.`)) return;
    try {
      await api.delete(`/equipes/${e.id}`);
      toast.success("Equipe excluída");
      load();
    } catch (err) {
      toast.error("Erro ao excluir equipe");
    }
  };

  return (
    <>
      <PageHeader
        testid="page-equipes"
        title="Equipes de Campo"
        subtitle={`${items.length} equipes cadastradas`}
        actions={<button className="btn btn-primary" onClick={() => { setForm(empty); setMembroTxt(""); setEditId(null); setModal(true); }} data-testid="btn-new-equipe"><Plus size={16} weight="bold" /> Nova equipe</button>}
      />
      <div className="page-body">
        {items.length === 0 ? (
          <EmptyState title="Nenhuma equipe cadastrada" />
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 16 }}>
            {items.map((e) => (
              <div key={e.id} className="pcp-card" style={{ padding: 16 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <div style={{ width: 32, height: 32, background: "#FFCC00", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: 3 }}>
                      <Users size={16} weight="bold" />
                    </div>
                    <div className="font-display font-bold">{e.nome}</div>
                  </div>
                  <div style={{ display: "flex", gap: 2 }}>
                    <button className="btn btn-ghost btn-sm" onClick={() => openEdit(e)} title="Editar"><Pencil size={14} weight="bold" /></button>
                    <button className="btn btn-ghost btn-sm" onClick={() => remove(e)} title="Excluir equipe" data-testid={`btn-del-equipe-${e.nome}`}><TrashSimple size={14} weight="bold" color="#DC2626" /></button>
                  </div>
                </div>
                <div style={{ fontSize: "0.8rem", color: "#52525B", marginBottom: 6 }}>
                  <strong>Supervisor:</strong> {e.supervisor || "—"}
                </div>
                <div style={{ fontSize: "0.8rem", color: "#52525B", marginBottom: 6 }}>
                  <strong>Região:</strong> {e.regiao || "—"}
                </div>
                <div style={{ fontSize: "0.8rem", color: "#52525B", marginBottom: 6 }}>
                  <strong>Veículos:</strong> {e.veiculos || "—"}
                </div>
                {e.membros?.length > 0 && (
                  <div style={{ marginTop: 12, display: "flex", flexWrap: "wrap", gap: 4 }}>
                    {e.membros.map((m, i) => <span key={i} className="chip">{m}</span>)}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      <Modal open={modal} onClose={() => setModal(false)} title={editId ? "Editar equipe" : "Nova equipe"}>
        <div style={{ display: "grid", gap: 12 }}>
          <F label="Nome *"><input className="input" value={form.nome} onChange={(ev) => setForm({ ...form, nome: ev.target.value })} data-testid="equipe-nome" required /></F>
          <F label="Supervisor"><input className="input" value={form.supervisor} onChange={(ev) => setForm({ ...form, supervisor: ev.target.value })} /></F>
          <F label="Membros (separados por vírgula)"><input className="input" value={membroTxt} onChange={(ev) => setMembroTxt(ev.target.value)} placeholder="João, Pedro, Maria" /></F>
          <F label="Veículos / equipamentos"><input className="input" value={form.veiculos} onChange={(ev) => setForm({ ...form, veiculos: ev.target.value })} /></F>
          <F label="Região / Estado"><input className="input" value={form.regiao} onChange={(ev) => setForm({ ...form, regiao: ev.target.value })} /></F>
        </div>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24 }}>
          <button className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
          <button className="btn btn-primary" onClick={save} data-testid="btn-save-equipe">Salvar</button>
        </div>
      </Modal>
    </>
  );
}
function F({ label, children }) { return <div><div className="label">{label}</div>{children}</div>; }
